<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">{{ 'New client' | translate }}</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-group">
            <input class="input" type="text" formControlName="name" placeholder="{{ 'Name' | translate }}" />
          </div>




          <div class="form-group">
            <input class="input" type="text" formControlName="address" placeholder="{{ 'address' | translate }}" />
          </div>
          @if(!isUpdatePage){
          <div class="form-group">
            <input class="input" type="text" formControlName="phone" placeholder="{{ 'Phone Number' | translate }}" />
          </div>
          }



          <div class="form-group">
            <input class="input" type="text" placeholder='تاريخ الرحلة' (focus)="type='date'"
              (blur)="!data.get('trip_date')?.value && (type='text')" [attr.type]="type" formControlName="trip_date" />
          </div>
          <div class="form-group">
            <input class="input" type="text" placeholder='تاريخ الوصول' (focus)="type='date'"
              (blur)="!data.get('arrival_date')?.value && (type='text')" [attr.type]="type"
              formControlName="arrival_date" />
          </div>
          <!-- باقي الفيلدات -->
          <div class="form-group">
            <input class="input" type="text" formControlName="passport_number"
              placeholder="{{ 'Passport' | translate }}" />
          </div>

          <div class="form-group">
            <select class="input" formControlName="trip_type">
              <option value="">-- اختر نوع الرحلة --</option>
              <option value="one_way">ذهاب فقط</option>
              <option value="round_trip">ذهاب وعودة</option>
              <option value="multi_city">مدن متعددة</option>
            </select>
          </div>

          <div class="form-group">
            <button type="submit" class="fromsave accont" [disabled]="data.invalid">
              @if(isUpdatePage){
              {{ 'Edit' | translate }}

              }
              @else{
              {{ 'Create Client' | translate }}

              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>